import { useEffect, useState } from "react";
import { useIntl } from 'react-intl';
import { Col, Row } from "reactstrap";
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import Toast from '../../helpers/Toast';
import { AssistanceAdditionalInfoUpdateDTO } from "../../models/Assistance/AssistanceAdditionalInfoUpdateDTO";
import { AssistanceDTO } from '../../models/Assistance/AssistanceDTO';
import { AssistanceService } from '../../services/AssistanceService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';

type AssistanceAdditionalInfoComponentType = {
  assistance: AssistanceDTO;
  isLoadingAssistance: boolean;
  setAssistance: Function;
}

export function AssistanceAdditionalInfoComponent({ assistance, isLoadingAssistance, setAssistance }: AssistanceAdditionalInfoComponentType) {
  const intl = useIntl();
  const assistanceService = new AssistanceService();
  const { workOrderName } = useAvailableModulesContext();

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);

  const editAssistance = async () => {
    var data: AssistanceAdditionalInfoUpdateDTO = {
      id: assistance.id,
      salesman: assistance.salesman ?? null,
      workOrder: assistance.workOrder ?? null,
      orderNumber: assistance.orderNumber ?? null,
      proposalNumber: assistance.proposalNumber ?? null,
      deliveryNoteNumber: assistance.deliveryNoteNumber ?? null,
      expectedHours: assistance.expectedHours ?? null,
    };

    setIsEditButtonLoading(true);
    var response = await assistanceService.EditAditionalInfo(data);
    if (response.success === false) {
      Toast.Show("error", response.message);
      setIsEditButtonLoading(false);
      return;
    }

    Toast.Show("success", response.message);
    setIsEditButtonLoading(false);
  };

  useEffect(() => {
    setIsComplete(!assistance.userCanEdit);
  }, [assistance]);

  return (
    <div className="pageComponent">
      <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>

        <InputComponent
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"text"}
          value={assistance?.workOrder ?? null}
          label={workOrderName ? workOrderName : "Ordem de Trabalho"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: string) => {
            setAssistance({ ...assistance!, workOrder: t });
          }}
        />

        <InputComponent
          xl={9}
          lg={9}
          md={9}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"text"}
          value={assistance?.proposalNumber ?? null}
          label={"Nº Proposta"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: string) => {
            setAssistance({ ...assistance!, proposalNumber: t });
          }}
        />

        <InputComponent
          xl={3}
          lg={3}
          md={3}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"number"}
          value={assistance?.expectedHours ?? null}
          label={"Horas Previstas de Trabalho"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: number) => {
            setAssistance({ ...assistance!, expectedHours: t });
          }}
        />

        <InputComponent
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"text"}
          value={assistance?.orderNumber ?? null}
          label={"Nº Encomenda"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: string) => {
            setAssistance({ ...assistance!, orderNumber: t });
          }}
        />

        <InputComponent
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"text"}
          value={assistance?.deliveryNoteNumber ?? null}
          label={"Nº Guia Transporte"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: string) => {
            setAssistance({ ...assistance!, deliveryNoteNumber: t });
          }}
        />

        <InputComponent
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{ width: "100%" }}
          type={"text"}
          value={assistance?.salesman ?? null}
          label={"Vendedor"}
          readOnly={isComplete}
          showLoadingSkeleton={isLoadingAssistance || isEditButtonLoading}
          onChange={(t: string) => {
            setAssistance({ ...assistance!, salesman: t });
          }}
        />
      </Row>

      {isComplete ? (
        ""
      ) : (
        <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
          <Col xl={3} lg={3} md={3} sm={12} xs={12}>
            <ButtonComponent
              style={{ width: "100%", marginTop: "10px" }}
              text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
              onClick={() => editAssistance()}
              disabled={isLoadingAssistance || isEditButtonLoading}
            />
          </Col>
        </Row>
      )}
    </div>
  )
}
